export default {
  'pages.layouts.userLayout.title':
    'EnderRealm Console - All-in-One Management Platform',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage':
    'Incorrect username/password(admin/ant.design)',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username: admin or user',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password: ant.design',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.phoneLogin.tab': 'Phone Login',
  'pages.login.phoneLogin.errorMessage': 'Verification Code Error',
  'pages.login.phoneNumber.placeholder': 'Phone Number',
  'pages.login.phoneNumber.required': 'Please input your phone number!',
  'pages.login.phoneNumber.invalid': 'Phone number is invalid!',
  'pages.login.captcha.placeholder': 'Verification Code',
  'pages.login.captcha.required': 'Please input verification code!',
  'pages.login.phoneLogin.getVerificationCode': 'Get Code',
  'pages.getCaptchaSecondText': 'sec(s)',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage':
    'Faster and stronger heavy-duty components have been released.',
  'pages.welcome.title': 'Welcome to EnderRealm Console',
  'pages.welcome.description':
    'EnderRealm Console is an all-in-one management platform that integrates staff management, in-service management, and load balancing. The unified design eliminates the need to switch between multiple systems, improving work efficiency. Access different modules quickly through the sidebar.',
  'pages.welcome.advantage.unified.title': 'Unified Management',
  'pages.welcome.advantage.unified.desc':
    'All management functions are centralized in one platform, eliminating the need to switch between multiple systems and significantly improving work efficiency.',
  'pages.welcome.advantage.efficient.title': 'Efficient & Convenient',
  'pages.welcome.advantage.efficient.desc':
    'Streamlined workflows reduce repetitive logins and data synchronization, making management tasks more seamless.',
  'pages.welcome.advantage.secure.title': 'Secure & Reliable',
  'pages.welcome.advantage.secure.desc':
    'Unified permission management and security policies ensure data security and consistent access control.',
  'pages.welcome.advantage.scalable.title': 'Flexible & Scalable',
  'pages.welcome.advantage.scalable.desc':
    'Modular design supports feature expansion, allowing flexible addition of new management modules based on business needs.',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  // Tools pages
  'pages.tools.title': 'Tools',
  'pages.tools.bedrockPackCrypto.title': 'Bedrock Pack Crypto',
  'pages.tools.bedrockPackCrypto.description': 'Encryption functionality for Bedrock resource packs to protect your creative content',
  'pages.tools.mcTextFormatter.title': 'MC Text Formatter',
  'pages.tools.expCurve.title': 'Exp Curve Tool',
};
